import { render, staticRenderFns } from "./MiniPackage.vue?vue&type=template&id=2400cfaa&scoped=true&"
import script from "./MiniPackage.vue?vue&type=script&lang=js&"
export * from "./MiniPackage.vue?vue&type=script&lang=js&"
import style0 from "./MiniPackage.vue?vue&type=style&index=0&id=2400cfaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2400cfaa",
  null
  
)

export default component.exports